import { FETCH_TENANT, SET_TENANT } from "redux/constants/flowDesigner";

export const fetchTenant = (tenant_id) => ({
  type: FETCH_TENANT,
  payload: { tenant_id },
});

export const setTenant = (payload) => ({
  type: SET_TENANT,
  payload,
});
